import React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

import Spinner from './spinner';

export default function LoadingSpinner({
  loadingFragment,
  size = 'sm',
  className,
}: {
  loadingFragment: string;
  size?: 'sm' | 'lg';
  className?: string;
}) {
  const [visible, setVisible] = useState(false);

  const { loadingFragments } = useSelector((state: RootState) => ({
    loadingFragments: state.global.loadingFragments,
  }));

  useEffect(() => {
    loadingFragments[loadingFragment] > 0
      ? setVisible(true)
      : setVisible(false);
  }, [loadingFragments, loadingFragment]);

  return <Spinner visible={visible} size={size} className={className} />;
}
